<template>
  <div v-if="locations">
    <md-table
      v-model="searched"
      md-sort="name"
      md-sort-order="asc"
      @md-selected="onSelect"
      md-card
      md-fixed-header
    >
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">{{title}}</h1>
          <md-button class="md-fab md-mini md-primary" @click="showCreateLocationDialog = true">
            <md-icon>add_location</md-icon>
            <md-tooltip>Create a new location</md-tooltip>
          </md-button>
          <md-button class="md-icon-button" @click="refetch()">
            <md-icon>refresh</md-icon>
            <md-tooltip>Refetch location</md-tooltip>
          </md-button>
        </div>

        <md-field md-clearable class="md-toolbar-section-end">
          <md-icon>search</md-icon>
          <md-input placeholder="Search by name..." v-model="search" @input="searchOnTable"/>
        </md-field>
      </md-table-toolbar>

      <md-table-empty-state md-label="No locations found" :md-description="emptyStateDescription"/>

      <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
        <md-table-cell md-label="Name" md-sort-by="name">{{ item.name }}</md-table-cell>
        <md-table-cell md-label="Address" md-sort-by="address">{{ item.address }}</md-table-cell>
        <md-table-cell md-label="Description" md-sort-by="description">{{ item.description }}</md-table-cell>
      </md-table-row>
    </md-table>

    <UpsertLocationDialog
      :show="showCreateLocationDialog"
      @onClose="showCreateLocationDialog = false"
    />
  </div>
  <div v-else>
    <md-progress-spinner class="wait" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"/>
  </div>
</template>

<style lang="scss" scoped>
.md-table {
  margin: 0px !important;
}
.md-field {
  max-width: 300px;
  margin-left: 2em;
}
.wait {
  margin: 2em;
}
</style>

<script>
import UpsertLocationDialog from "@/components/dialogs/upsertLocationDialog.vue";

const toLower = text => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.name).includes(toLower(term)));
  }

  return items;
};

export default {
  name: "Locations",
  components: { UpsertLocationDialog },
  props: {
    title: String,
    locations: Array
  },
  data: () => ({
    showCreateLocationDialog: false,
    search: null,
    searched: []
  }),
  computed: {
    currentUser: {
      get() {
        return this.$store.state.currentUser;
      }
    },
    emptyStateDescription: {
      get() {
        const result = [];
        if (this.search)
          result.push(
            `No locations matching the name '${
              this.search
            }'.  Try a different search term.`
          );
        else result.push("There are no locations to display.");
        return result.join(" ");
      }
    }
  },
  methods: {
    searchOnTable() {
      this.searched = searchByName(this.locations, this.search);
    },
    onSelect(item) {
      this.$store.commit("setCurrentLocationId", item.id);
      this.$router.push({ path: "/location" });
    },
    copyEntity() {
      if (this.locations) this.searched = this.locations.slice(0);
    },
    refetch() {
      this.$root.$emit("updateLocation", null);
    }
  },
  watch: {
    locations() {
      this.copyEntity();
    }
  },
  created() {
    this.copyEntity();
  }
};
</script>




// WEBPACK FOOTER //
// locations.vue?13a119b1